import React from "react"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { Image, Typography, Space, Table, Tag } from "antd"
import image1 from "../../../../assets/images/finance/1.jpg"
import image2 from "../../../../assets/images/finance/2.jpg"
import image3 from "../../../../assets/images/finance/3.jpg"
import image4 from "../../../../assets/images/finance/4.jpg"
import image5 from "../../../../assets/images/finance/5.jpg"
import image6 from "../../../../assets/images/finance/6.jpg"

const Index = props => {
  const { t } = props

  const reports = [
    { id: 6, year: "1404", period: "منتهی به 29-12-1404", title: "گزارش مالی منتهی به 29-12-1404", src: image6 },
    { id: 5, year: "1403", period: "منتهی به 29-12-1403", title: "گزارش مالی منتهی به 29-12-1403", src: image5 },
    { id: 4, year: "1403", period: "سه ماهه چهارم", title: "گزارش مالی سه ماهه چهارم 1403", src: image4 },
    { id: 3, year: "1403", period: "سه ماهه سوم", title: "گزارش مالی سه ماهه سوم 1403", src: image3 },
    { id: 2, year: "1403", period: "سالانه", title: "گزارش عملکرد مالی 1403", src: image2 },
    { id: 1, year: "1402", period: "سالانه", title: "گزارش عملکرد مالی 1402", src: image1 },
  ]

  const columns = [
    {
      title: "سال",
      dataIndex: "year",
      key: "year",
      width: 90,
      align: "center",
      render: year => <Tag color="blue-inverse">{year}</Tag>,
    },
    {
      title: "دوره",
      dataIndex: "period",
      key: "period",
      width: 140,
      render: period => <Typography.Text>{period}</Typography.Text>,
    },
    {
      title: "عنوان گزارش",
      dataIndex: "title",
      key: "title",
      ellipsis: true,
    },
    {
      title: "نمایش",
      dataIndex: "src",
      key: "preview",
      width: 140,
      align: "center",
      render: (src, record) => (
        <Image.PreviewGroup>
          <Image
            src={src}
            alt={record.title}
            width={96}
            height={96}
            style={{ objectFit: "cover", borderRadius: 8 }}
          />
        </Image.PreviewGroup>
      ),
    },
  ]
  return (
    <>
      <Space direction="vertical" style={{ width: "100%" }} size="large">
        <Typography.Title level={5} style={{ margin: 0 }}>
          {t ? t("گزارش‌های مالی") : "گزارش‌های مالی"}
        </Typography.Title>
        <Table
          rowKey="id"
          dataSource={reports}
          columns={columns}
          pagination={false}
          size="middle"
        />
      </Space>
    </>
  )
}

export default withRouter(withTranslation()(Index))
